import Page from '@app/components/layout/page/page';
import { useItemScope } from '@app/purchased-goods/components/item-detail/use-item-scope';
import { OverallSpendSection } from '@app/purchased-goods/components/spend/overall-spend-section';
import { PriceChangesSection } from '@app/purchased-goods/components/spend/price-changes-section';
import { getMonthlyPeriodsInWindow } from '@app/purchased-goods/components/spend/utils';
import { useAccount } from '@shared/api';
import { useGetPurchasedPackagingItemSpend } from '@shared/api/hooks/purchased-goods/packaging';
import { useGetTimePeriods } from '@shared/api/hooks/reports/periods';
import Loader from '@shared/components/loader';
import { useMemo } from 'react';
import { usePurchasedPackagingItem } from '../purchased-packaging-item-context';

export default function PurchasedPackagingItemSpendPage() {
  const { item } = usePurchasedPackagingItem();
  const { data: account } = useAccount(true);
  const { recordsParams } = useItemScope();

  const { data: periods } = useGetTimePeriods();

  const {
    data: spend,
    status,
    isFetching: isSpendFetching,
  } = useGetPurchasedPackagingItemSpend({
    activityUuid: item.uuid,
    params: recordsParams,
  });

  const monthlyPeriods = useMemo(
    () =>
      getMonthlyPeriodsInWindow(
        periods,
        spend?.timePeriodStart?.startDate,
        spend?.timePeriodEnd?.endDate
      ),
    [periods, spend?.timePeriodStart, spend?.timePeriodEnd]
  );

  const unitSymbol = item?.itemUnit?.symbol || 'unit';
  const hasData = spend && spend.spendOverTime.length > 0;

  return (
    <Page
      name={`${item?.packagingName ?? 'Item'} spend`}
      page="subpage"
      status={status}
      flexFullHeight
    >
      <div className="flex flex-col gap-8 pt-2 pb-12">
        {hasData ? (
          <>
            <OverallSpendSection
              spend={spend}
              currency={account?.defaultCurrency}
              monthlyPeriods={monthlyPeriods}
              categoryLabel="packaging"
            />
            <PriceChangesSection
              spend={spend}
              currency={account?.defaultCurrency}
              unitSymbol={unitSymbol}
              monthlyPeriods={monthlyPeriods}
            />
          </>
        ) : isSpendFetching ? (
          <Loader className="h-64" />
        ) : (
          <div className="rounded-lg border border-dashed p-8 text-center text-sm text-gray-500">
            No spend data available for this item yet.
          </div>
        )}
      </div>
    </Page>
  );
}
